import { Modal, Paper } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { endOfDay } from "date-fns";
import Stack from "@mui/material/Stack";
import DateRangePickerNew from "src/components/date-range-picker-new";

const ModalContainer = styled(Paper)`
    position: absolute;
    top: 30%;
    left: 30%;
`;

const RangePickerModalAnalysis = ({ handleClose, open, toggleDatepicker, setSelectedTime }) => {
    const maxDate = endOfDay(new Date());
    const handleDateChange = (startDate, endDate) => {
        setSelectedTime({ from: startDate, to: endDate });
    };
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
        >
            <ModalContainer>
                <Stack direction="column">
                    <DateRangePickerNew
                        toggle={toggleDatepicker}
                        maxDate={maxDate}
                        handleChange={handleDateChange}
                        toggleDatepicker={toggleDatepicker}
                    />
                </Stack>
            </ModalContainer>
        </Modal>
    );
};
export default RangePickerModalAnalysis;
